/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Prereq_Resume_LinkInputs */

const en_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Resumes`)
};

const de_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Lebenslaeufen`)
};

const fr_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller aux CV`)
};

const es_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a curriculos`)
};

const it_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai ai CV`)
};

const nl_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar cv's`)
};

const pl_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdz do CV`)
};

const fi_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry ansioluetteloihin`)
};

const da_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga til CV'er`)
};

const sv_cover_letters_prereq_resume_link = /** @type {(inputs: Cover_Letters_Prereq_Resume_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga till CV:n`)
};

/**
* | output |
* | --- |
* | "Go to Resumes" |
*
* @param {Cover_Letters_Prereq_Resume_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_prereq_resume_link = /** @type {((inputs?: Cover_Letters_Prereq_Resume_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Prereq_Resume_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_prereq_resume_link(inputs)
	if (locale === "fr") return fr_cover_letters_prereq_resume_link(inputs)
	if (locale === "es") return es_cover_letters_prereq_resume_link(inputs)
	if (locale === "it") return it_cover_letters_prereq_resume_link(inputs)
	if (locale === "nl") return nl_cover_letters_prereq_resume_link(inputs)
	if (locale === "pl") return pl_cover_letters_prereq_resume_link(inputs)
	if (locale === "fi") return fi_cover_letters_prereq_resume_link(inputs)
	if (locale === "da") return da_cover_letters_prereq_resume_link(inputs)
	if (locale === "sv") return sv_cover_letters_prereq_resume_link(inputs)
	return en_cover_letters_prereq_resume_link(inputs)
});